import { _, locale } from "i18n";
import type { Keys } from "i18n/locales/types";
import React, { ReactNode } from "react";
import { getDateFormat } from "ui-kit/src/functions";

type CellVariant = 'header' | 'data' | 'date' | 'action';

interface BaseCellProps {
    padding?: string;
    children?: ReactNode;
}

interface HeaderCellProps extends BaseCellProps {
    variant: 'header';
    translationKey: string;
}

interface DataCellProps extends BaseCellProps {
    variant: 'data';
    value?: string | number | null;
}

interface DateCellProps extends BaseCellProps {
    variant: 'date';
    value?: string | number | null;
}

interface ActionCellProps extends BaseCellProps {
    variant: 'action';
}

type CellProps = HeaderCellProps | DataCellProps | DateCellProps | ActionCellProps;

export const Cell: React.FC<CellProps> = (props) => {
    const { variant, padding, children } = props;
    const style = { padding: padding ?? '8px' };

    if (variant === 'header') {
        return (
            <div style={style}>
                {_(props.translationKey as keyof Keys).toUpperCase()}
            </div>
        );
    }

    if (variant === 'date') {
        if (!props.value) {
            return <div style={style}>-</div>;
        }

        const date = new Date(props.value.toString().endsWith('Z') ? props.value.toString() : props.value.toString() + 'Z');
        const formattedDate = date.toLocaleDateString(getDateFormat(locale)) + ' ' + date.toLocaleTimeString(getDateFormat(locale));
        return <div style={style}>{formattedDate}</div>;
    }

    if (variant === 'action') {
        return (
            <div style={style}>
                <div className="api-actionsCell">
                    {children}
                </div>
            </div>
        );
    }

    if (children) {
        return <div style={style}>{children}</div>;
    }
    return <div style={style}>{props.value?.toString() ?? "-"}</div>;
};
